import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash'
import * as rd from "diacritics"
import moment from 'moment'

import {
  Table,
  Jumbotron,
  Button,
  Tabs,
  Tab,
  Row,
  Grid,
  Col,
  Modal,
  Image,
  Glyphicon,
  Panel,
  ButtonGroup,
  FormControl,
  FormGroup,
  ControlLabel,
  Label
} from 'react-bootstrap';

import If from "../../utils/If"

import Loader from 'react-loader-advanced';

import '../../statics/css/table-exercises.css'
import '../../statics/css/evaluation-list.css'

import videoPlayerIcon from '../../statics/images/video_player.svg'

//DAO
import { updateUser } from '../../dao-firebase/user-firebase'
import { deletePdfEvaluationFileStorage } from '../../dao-firebase/daofirebase'

class ListPdfsAvaliations extends Component {

  constructor(props) {
    super(props);

    this.state = {

      aluno: this.props.aluno,
      typeEvaluation: this.props.typeEvaluation,
      evaluations: this.props.aluno.data.evaluations[this.props.typeEvaluation],
      closeModal: this.props.closeModal,
      startLoader: this.props.startLoader,
      stopLoader: this.props.stopLoader,

    };

    moment.locale();

  }

  componentDidMount() {

  }

  componentWillMount() {

  }

  verifySearch(obj) {

    let nameObjFormat = rd.remove(obj.name.toLowerCase());
    let searchFormat = rd.remove(this.props.search.toLowerCase());
    return nameObjFormat.includes(searchFormat);
  }

  viewEvaluation(link) {
    window.open(link);
  }

  removeEvaluation(evaluation) {

    console.log("TO REMOVE:", evaluation);

    this.state.startLoader();

    deletePdfEvaluationFileStorage(this.state.aluno.id, this.state.typeEvaluation, evaluation.dateInMillis, (message, success) => {
      console.log(message);
      if (success) {

        let newArrayEvaluations = [];

        const oldArrayEvaluations = this.state.aluno.data['evaluations'][this.state.typeEvaluation];

        console.log('typeEvaluation: ', this.state.typeEvaluation);
        console.log('oldArrayEvaluations: ', oldArrayEvaluations);

        oldArrayEvaluations.forEach(evaluationInArray => {
          if (evaluationInArray.dateInMillis != evaluation.dateInMillis) {
            newArrayEvaluations.push(evaluationInArray);
          }
        });

        this.state.aluno.data['evaluations'][this.state.typeEvaluation] = newArrayEvaluations;

        updateUser(JSON.parse(localStorage.getItem("USER")).uid,
          this.state.aluno,
          (response, success) => {

            this.state.stopLoader();
            if (success) {

              this.state.closeModal('Arquivo removido com sucesso!');

            } else {

              this.state.closeModal('Falha ao remover arquivo!');

            }
          })
      } else {
        this.state.stopLoader();
        this.state.closeModal('Falha ao remover arquivo!');
      }
    });
  }

  renderAvaliations() {

    return _.map(this.state.evaluations, (evaluation) => {

      return (

        <tr className="item-evaluation-list">

          <td className="icon-file-evaluation">
            <Glyphicon className="action-exercise edit-data-exercise" glyph="file" />
          </td>

          <td className="data-evaluation">
            <p><b>{moment(new Date(evaluation.dateInMillis)).format("DD MMM YYYY, HH:mm:ss")}</b></p>
          </td>

          <td className="actions-evaluation middle-td">

            <Button bsStyle="primary" onClick={() => this.viewEvaluation(evaluation.linkPdf)}>Visualizar</Button>
            <Button className="remove-data-evaluation" bsStyle="danger" onClick={() => this.removeEvaluation(evaluation)}><Glyphicon glyph="trash" /></Button>
            {/* <Glyphicon className="action-exercise edit-data-exercise" glyph="search" onClick={() => this.viewEvaluation(evaluation.linkPdf)} />
            <Glyphicon className="action-exercise remove-data-exercise" glyph="remove" onClick={() => this.removeEvaluation()} /> */}
          </td>

        </tr>

      )
    })
  }

  render() {

    return (
      <div className="evaluation-list-page">
        <Table className={this.props.customClass ? this.props.customClass : ""} responsive>

          <tbody>
            {this.renderAvaliations()}
          </tbody>
        </Table>
      </div >
    );
  }
}

export default ListPdfsAvaliations;


// WEBPACK FOOTER //
// src/components/alunos/avaliation-list.js